import React from 'react';
import './style/points.css';

export default function Points(props) {
  return (
    <div className="points">
      Points

      <div>
        YOU HAVE 2879238 POINTS!
        <button>REDEEM</button>
      </div>

      <div>
        POINT HISTORY

        <p>
          sdfkjhsdjkhdkjhsdfjkhfsdjkhdsjk
        </p>
      </div>
    </div>
  );
}
